module.exports = {
	"articleTitle1": "Jug history at forefront of Michigan's preparation for Big Ten opener",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Brown Jug",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/are-fake-ids-worth-risk",
	"articleSnippet1": "Oct 3, 2013 ... There's the Little Brown Jug to protect, after all. Last Sunday marked the official \nend of the bye and the start of Minnesota week. Michigan coach ...",
	"articleSnippet2": "Jan 9, 2003 ... The Brown Jug pays its employees $10 for each ID they take. While some minors \nmay think this is wrong and cruel, Gradillas explains that this ...",
	"foodRecommendations": [
		{
			"text": "Wouldn't have done my undergrad at UofM if not for Brown Jug's home-y atmosphere.",
			"person": "Ian McKenzie"
		},
		{
			"text": "Karaoke on Sundays!",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Are fake IDs worth the risk?",
	"address": "1204 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2748,
		"lng": -83.7343
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/brownjug.json
// module id = 836
// module chunks = 0